import { useSearchParameters } from 'hooks/useSearchParameters';
import { useTranslation } from 'react-i18next';
import { queryKeys } from 'utils/query';
import { WorklistStatus } from 'models/worklist';
import { EmptyParametersError } from 'services/errors/EmptyParametersError';
import { useCustomMutation } from '../useCustomMutation';
import { updateWorklistRecord } from './useUpdateWorklistRecord';

export const updateWorklistRecords = async (variables: { ids: string[]; status: WorklistStatus }) => {
  const { ids, status } = variables;

  if (!ids) throw new EmptyParametersError();

  for await (const id of ids) {
    await updateWorklistRecord({ id, status });
  }

  return true;
};

export const useUpdateWorklistRecords = () => {
  const { parameters: filters } = useSearchParameters(queryKeys.worklistOverview);
  const { t } = useTranslation();
  return useCustomMutation({
    fn: updateWorklistRecords,
    onSuccess: { message: t('update_worklist_success') },
    onSettled: { invalidateQueryKeys: [[queryKeys.worklistOverview, filters]] },
  });
};
